/**
 * Simple XOR-based encryption/decryption with URL-safe Base64 encoding.
 * This is used to obfuscate query parameters from bots and curious users.
 * It is not high-security encryption, but sufficient for this use case.
 */

const SECRET_KEY = 'koent-domain-sentinel-secret-key';

/**
 * Encodes a string to URL-safe Base64
 */
const toUrlSafeBase64 = (str: string): string => {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

/**
 * Decodes a URL-safe Base64 string
 */
const fromUrlSafeBase64 = (str: string): string => {
  str = str.replace(/-/g, '+').replace(/_/g, '/');
  while (str.length % 4) {
    str += '=';
  }
  return atob(str);
};

/**
 * Encrypts a string using XOR and then encodes to URL-safe Base64
 */
export const encrypt = (text: string): string => {
  let result = '';
  for (let i = 0; i < text.length; i++) {
    result += String.fromCharCode(text.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length));
  }
  return toUrlSafeBase64(result);
};

/**
 * Decrypts a URL-safe Base64 string using XOR
 */
export const decrypt = (encodedText: string): string | null => {
  try {
    const text = fromUrlSafeBase64(encodedText);
    let result = '';
    for (let i = 0; i < text.length; i++) {
      result += String.fromCharCode(text.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length));
    }
    return result;
  } catch (e) {
    console.error('Failed to decrypt parameter:', e);
    return null;
  }
};
